import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { providePresentia } from '@reforgium/presentia';
import { provideStatum } from '@reforgium/statum';
import { provideSkUi } from '@ss/ui';

import { authInterceptor } from 'providers/auth.interceptor';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    providePresentia({
      lang: {
        source: {
          url: 'assets/locales',
          fromAssets: true,
          defaultLang: 'ru',
          fallbackLang: 'ru',
          supportedLangs: ['ru', 'ky'],
          kgValue: 'ky',
        },
      },
      theme: {
        defaultTheme: 'light',
        dom: { darkClassName: 're-dark' },
      },
      adaptive: {
        breakpoints: {
          'mobile': '(max-width: 719px)',
          'tablet': '(min-width: 720px) and (max-width: 1399px)',
          'desktop-s': '(min-width: 1400px) and (max-width: 1919px)',
          'desktop': '(min-width: 1920px)',
        },
      },
    }),
    provideSkUi(),
    provideStatum({
      pagedQuery: {
        defaultMethod: 'GET',
        defaultQuery: { pageSize: 20, page: 0 },
        defaultHasCache: false,
      },
    }),
    { provide: LOCALE_ID, useValue: 'ru' },
  ],
};
